import { ComponentProps, FunctionComponent } from 'react';
import styled from 'styled-components';

import { LegacyButton as Button } from 'components/Button/LegacyButton';

import { buttonStyles } from './buttonStyles';

type Props = ComponentProps<typeof Button> & {
  size?: 'small' | 'medium' | 'large';
  boxShadow?: string;
  reverse?: boolean;
  blue?: boolean;
  green?: boolean;
  light?: boolean;
  $transparent?: boolean;
};

export const ButtonWithStyles: FunctionComponent<Props> = styled(
  ({
    size: sizeProp,
    boxShadow,
    borderRadius,
    reverse,
    blue,
    light,
    ...buttonProps
  }: Props) => (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Button {...buttonProps} />
  )
).attrs((props) => ({
  type: props.type === undefined ? 'button' : props.type,
}))`
  ${buttonStyles}
`;
